var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinks(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12968",
    "data-name": "Group 12968",
    transform: "translate(1653 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12965",
    "data-name": "Group 12965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21079",
    "data-name": "Path 21079",
    d: "M-1630,49a23.026,23.026,0,0,1-23-23,23.026,23.026,0,0,1,23-23,23.026,23.026,0,0,1,23,23A23.026,23.026,0,0,1-1630,49Zm0-44a21.023,21.023,0,0,0-21,21,21.023,21.023,0,0,0,21,21,21.023,21.023,0,0,0,21-21A21.023,21.023,0,0,0-1630,5Z",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12966",
    "data-name": "Group 12966"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4307",
    "data-name": "Rectangle 4307",
    width: 2,
    height: 24,
    transform: "translate(-1631 14)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12967",
    "data-name": "Group 12967"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4308",
    "data-name": "Rectangle 4308",
    width: 24,
    height: 2,
    transform: "translate(-1642 25)",
    fill: "#010101"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinks);
export default __webpack_public_path__ + "static/media/links.2c7b92258c11c33bbdc95ec05714a29a.svg";
export { ForwardRef as ReactComponent };